import Fuse from 'fuse.js'
import axios from 'axios'
import { markRaw } from 'vue'
import Model from '../model'
import Result from '../result'
import Component from '@/components/search/elements/HelpGuide.vue'

class HelpGuide extends Model {
  constructor (options = {}) {
    super(options)

    this.name = 'Help Guides'
    this.component = Component

    this.items = []
    this.fuse = null
    this.initPromise = null
  }

  init () {
    if (this.items.length) return Promise.resolve()
    if (this.initPromise) return this.initPromise

    this.syncing = true

    this.initPromise = axios.get('https://help.ovatu.com/api/help/menu?product=next')
      .then((response) => {
        this.items = response.data.data.topics.map((topic) => {
          return topic.articles.map(article => ({
            label: article.name,
            info: topic.name,
            link: `https://help.ovatu.com/${topic.slug}/${article.slug}`,
            icon: topic.iconCss,
          }))
        }).flat()
        this.fuse = null
      })
      .catch((error) => {
        console.error('Error fetching help guides:', error)
      })
      .finally(() => {
        this.syncing = false
        this.initPromise = null
      })

    return this.initPromise
  }

  search (query) {
    if (!this.fuse) {
      this.fuse = markRaw(new Fuse(this.items, {
        keys: ['label', 'info'],
      }))
    }

    const results = this.fuse.search(query)
    const filtered = results.map(({ item }) => new HelpGuideResult({ data: item }))

    // Limit results if needed
    filtered.length = Math.min(filtered.length, 5)

    this.results = filtered
  }
}

class HelpGuideResult extends Result {
  get path () {
    return this.data.link
  }
}

export default new HelpGuide()
